var _rect, _rect2, _rect3, _rect4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 6 4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#00A551",
    width: 6,
    height: 4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "#FFD500",
    width: 6,
    height: 3
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    fill: "#1A206D",
    width: 6,
    height: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    fill: "#EA2839",
    width: 6,
    height: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMu);
export default __webpack_public_path__ + "static/media/mu.c4aa8b71da07d356eaf52ca5b44374ab.svg";
export { ForwardRef as ReactComponent };